var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', [_c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }), _c('b-col', {
    staticClass: "d-flex justify-content-end align-items-center",
    attrs: {
      "lg": "8"
    }
  }, [_vm.$permissionAbility(_vm.USER_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showUserModal
    }
  }, [_vm._v(" Create User ")])] : _vm._e()], 2)], 1), _c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "total-rows": _vm.totalRecords,
      "is-loading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'id',
          type: 'desc'
        }, {
          field: 'name',
          type: 'desc'
        }, {
          field: 'created_at',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      },
      "style-class": "vgt-table striped"
    },
    on: {
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        return [props.column.field === 'sl' ? _c('span', [_vm._v(" " + _vm._s((_vm.serverParams.page - 1) * _vm.serverParams.perPage + props.index + 1) + " ")]) : _vm._e(), props.column.field === 'status_formated' ? _c('span', [props.row.status === 1 ? _c('span', {
          staticClass: "badge bg-success"
        }, [_vm._v("Active")]) : _c('span', {
          staticClass: "badge bg-danger"
        }, [_vm._v("Inactive")])]) : _vm._e(), props.column.field === 'created_at_formated' ? _c('span', [_vm._v(" " + _vm._s(new Date(props.row.created_at).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        })) + " ")]) : _vm._e(), props.column.field === 'action' ? _c('span', [_vm.$permissionAbility(_vm.USER_EDIT, _vm.permissions) ? [_c('span', {
          on: {
            "click": function click($event) {
              return _vm.onShow(props.row);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "Edit2Icon",
            "title": "Edit",
            "size": "16"
          }
        })], 1)] : _vm._e(), _vm.$permissionAbility(_vm.USER_DELETE, _vm.permissions) ? [_c('span', [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "Trash2Icon",
            "title": "Delete",
            "size": "16"
          },
          on: {
            "click": function click($event) {
              return _vm.onDelete(props.row);
            }
          }
        })], 1)] : _vm._e(), _c('span', {
          on: {
            "click": function click($event) {
              return _vm.viewRoles(props.row);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "EyeIcon",
            "title": "View Roles",
            "size": "16"
          }
        })], 1)], 2) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-view-roles",
      "centered": "",
      "title": 'Roles Assigned to ' + _vm.selectedUser.name,
      "hide-footer": "",
      "size": "md"
    },
    on: {
      "hidden": _vm.hiddenRolesModal
    }
  }, [_c('b-list-group', [_vm._l(_vm.selectedUser.roles, function (role) {
    return _c('b-list-group-item', {
      key: role.id
    }, [_vm._v(" " + _vm._s(role.name) + " ")]);
  }), !_vm.selectedUser.roles || _vm.selectedUser.roles.length === 0 ? _c('b-list-group-item', {
    staticClass: "text-muted"
  }, [_vm._v(" No roles assigned ")]) : _vm._e()], 2), _c('div', {
    staticClass: "mt-3 text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-view-roles');
      }
    }
  }, [_vm._v(" Close ")])], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-user",
      "centered": "",
      "title": _vm.modelType === 'editModel' ? 'Edit User' : 'Create User',
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "hidden": _vm.hiddenUserModal
    }
  }, [_c('validation-observer', {
    ref: "userForm"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validUserForm($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Name",
      "label-for": "name"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Name",
      "vid": "name",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter name"
          },
          model: {
            value: _vm.name,
            callback: function callback($$v) {
              _vm.name = $$v;
            },
            expression: "name"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Email",
      "label-for": "email"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Email",
      "vid": "email",
      "rules": "required|email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "email",
            "type": "email",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter email"
          },
          model: {
            value: _vm.email,
            callback: function callback($$v) {
              _vm.email = $$v;
            },
            expression: "email"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Roles",
      "label-for": "role_ids"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Roles",
      "vid": "role_ids"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-select', {
          attrs: {
            "id": "role_ids",
            "options": _vm.roleOptions,
            "multiple": "",
            "select-size": 4,
            "state": errors.length > 0 ? false : null
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('option', {
                attrs: {
                  "value": "",
                  "disabled": ""
                }
              }, [_vm._v(" Select roles (multiple selection) ")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.role_ids,
            callback: function callback($$v) {
              _vm.role_ids = $$v;
            },
            expression: "role_ids"
          }
        }), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Hold Ctrl/Cmd to select multiple roles")]), _c('small', {
          staticClass: "text-danger d-block"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.selectedRoles.length > 0 ? _c('b-form-group', {
    attrs: {
      "label": "Selected Roles:",
      "label-for": "selected-roles-preview"
    }
  }, [_c('div', _vm._l(_vm.selectedRoles, function (role) {
    return _c('b-badge', {
      key: role.value,
      staticClass: "mr-1 mb-1",
      attrs: {
        "variant": "info"
      }
    }, [_vm._v(" " + _vm._s(role.text) + " "), _c('feather-icon', {
      staticClass: "cursor-pointer ml-1",
      attrs: {
        "icon": "XIcon",
        "size": "12"
      },
      on: {
        "click": function click($event) {
          return _vm.removeRole(role.value);
        }
      }
    })], 1);
  }), 1)]) : _vm._e(), _vm.modelType !== 'editModel' ? _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Password",
      "label-for": "password"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Password",
      "vid": "password",
      "rules": "required|min:6"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "password",
            "type": "password",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter password"
          },
          model: {
            value: _vm.password,
            callback: function callback($$v) {
              _vm.password = $$v;
            },
            expression: "password"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 3048305370)
  })], 1) : _vm._e(), _vm.modelType !== 'editModel' ? _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Confirm Password",
      "label-for": "password_confirmation"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Password Confirmation",
      "vid": "password_confirmation",
      "rules": "required|confirmed:password"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "password_confirmation",
            "type": "password",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Re-enter password"
          },
          model: {
            value: _vm.password_confirmation,
            callback: function callback($$v) {
              _vm.password_confirmation = $$v;
            },
            expression: "password_confirmation"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 3969387520)
  })], 1) : _vm._e(), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Status",
      "label-for": "status"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Status",
      "vid": "status",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-select', {
          attrs: {
            "id": "status",
            "options": _vm.statusOptions,
            "state": errors.length > 0 ? false : null
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('option', {
                attrs: {
                  "value": "",
                  "disabled": ""
                }
              }, [_vm._v(" Select status ")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.status,
            callback: function callback($$v) {
              _vm.status = $$v;
            },
            expression: "status"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.isUserFormSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }